<template>
    <section>
        <div class="container">
            <CommonBreadcrumb class="bread_block_mod" /> 
        </div>

        <div class="px-0 container-fluid">
            <div class="guide_block_banner">
                <div class="eng_guide_banner">
                    <picture>
                    <source width="1920" height="540" type="image/webp" srcset="~/assets/eng-guide/step/banner.webp">
                    <img  height="540" width="1920" type="image/jpeg" src="~/assets/eng-guide/step/banner.jpg" alt="Engagement Ring Guide" />
                    </picture>
                    <div class="eng_guide_upper">
                        <h1 class="font-active"><span>how to buy an</span>engagement ring ?</h1>
                        <div class="eng_guide_flex my-3">
                            <NuxtLink class="me-2 radious_four" :to="localePath({ name:'cyo-setting-list-ring'})">Start with a Setting</NuxtLink>
                            <NuxtLink class="radious_four" :to="localePath({ name:'cyo-diamond-list-ring'})">Start with a Diamond</NuxtLink>
                        </div>
                        <p class="mb-0" v-if="$country.is_india">Our aim at Friendly Diamonds is to make the process of buying a perfect engagement ring as easy as possible. This guide will show you how to create a unique engagement ring that you can treasure forever.</p>
                        <p class="mb-0" v-else>Our aim at Friendly Diamonds is to make the process of buying a perfect engagement ring as easy as possible. This guide will show you how to choose a unique engagement ring that you can treasure forever.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-md mt-5">
            <div class="guide_block pb-4">
                <h2 class="mb-3 font-active" v-if="$country.is_india">A Journey Of Love: How To Choose An Engagement Ring? </h2>
                <h2 class="mb-3 font-active" v-else>how to pick an engagement ring ?</h2>
                <p v-if="$country.is_india">
                    Choosing an engagement ring is very personal and involves deep sentiments. It is a token of cherished love that marks the beginning of a new chapter in a couple's life. The journey is filled with never-ending feelings because of the excitement that comes along with finding the perfect ring and sharing the special moment with close friends and family.
                    <br><br>
                    Finding an <NuxtLink :to="localePath({ name:'cyo-setting-list-ring'})">engagement ring design</NuxtLink> that reflects your partner's and your particular style is crucial, especially considering the wide range of jewellery tastes. A <NuxtLink :to="localePath('/engagement-rings')" >diamond engagement ring</NuxtLink> symbolises your vision and acts as a reflection of your special love story.
                    <br><br>
                    The brilliance and sparkle of diamonds evoke feelings of joy and happiness that symbolise everlasting love, making them the perfect choice for an engagement ring. They represent strength and resilience, qualities that are valued in a long loving relationship.
                    <br><br>
                    Each aspect of the ring is the significance of your eternal love; hence, the process of choosing an engagement ring should not be rushed. It is important to be patient and take the time to consider the different styles, settings, and quality of the diamond.
                    <br><br>
                    We've put together a quick guide to walk you through the entire process.
                </p>
                <p v-else>
                    An engagement ring is a classic and timeless representation of love. It is a symbol that signifies the love you share with your dearly beloved. It should resonate with your partner, speak to his or her heart, and be the perfect match that pairs well with his or her personality and style. <br><br>
                    But choosing the perfect <NuxtLink :to="localePath('/engagement-rings')">engagement ring</NuxtLink> is not always easy. While you may consider your engagement ring to be of any type, there is no surprise that diamond engagement rings are the most popular of all engagement rings. <br><br>
                    Diamonds, as it is said, are forever. It is the perfect gemstone known for its strength, resilience, durability, and sparkling shine. They have all the qualities that describe true and timeless love. And represent all that makes each love unique, considering how every diamond is unlike each other.
                    They are the most traditional gemstone used on engagement rings and continue to be the choice of modern couples today. So if you’re going to shop for an engagement ring choosing a <NuxtLink :to="localePath({ name:'cyo-diamond-list-ring'})">diamond ring</NuxtLink> is the perfect pick. <br><br>
                    At Friendly Diamonds, we understand the importance of your proposal moment. It is a landmark moment in your life and requires you to find the perfect engagement ring. We aim to make your engagement ring shopping experience the easiest. Keeping this goal in mind, we have crafted the perfect engagement ring guide that guides you when choosing an engagement ring that you and your partner shall cherish for life.
                </p>
            </div>
            
            <div class="row guide_block align-items-center py-4">
                <div class="col-md-5 col-12 ">
                    <picture>
                        <source width="445" height="382" type="image/webp" srcset="~/assets/eng-guide/step/set_budget.webp">
                        <img loading="lazy" class="my-3 radious_eight" height="382" width="445" type="image/jpeg" src="~/assets/eng-guide/step/set_budget.jpg" alt="Set a budget">
                    </picture>
                </div>
                
                <div class="col-md-7 col-12 guide_block pb-4">
                    <h5>Step 1</h5>
                    <h4 class="font-active">Set A Budget</h4>
                    <p v-if="$country.is_india">            
                        Setting a budget isn't about limiting yourself; it's about finding a ring that you cherish within your means. It's your roadmap, steering you towards the perfect blend of sentiment and cost. 
                        <br><br>
                        Planning a budget gives you a clear idea of what you can afford. It narrows down your options, making the decision-making process a lot easier. It keeps you from going over budget and prevents unnecessary financial stress. Setting a budget is like making a thoughtful decision aligned with the current financial situation and plans.
                        <br><br>
                        If you choose a <NuxtLink :to="localePath('/lab-diamonds')">lab diamonds</NuxtLink>, it is not just easy on the environment but also pocket-friendly. Different <NuxtLink :to="localePath('/engagement-ring-guide/types-of-diamonds')">diamond shapes</NuxtLink> come with different price tags, so exploring in depth will help you find what suits your taste and budget. 
                        <br><br>
                        Stick to your plan, and you'll discover the perfect combination for a ring that beautifully symbolises your personal love story. 
                    </p>
                    <p v-else>
                        Your proposal/engagement moment is one of the most significant moments of your life. It is wise to consider how much you'd like to spend on your engagement ring by setting a budget so that you have a certain point to start from when considering your ring choices. <br><br>
                        Your budget will guide you in determining the <NuxtLink :to="localePath('/blog/types-of-engagement-ring')">type of ring</NuxtLink> metal, ring setting, and <NuxtLink :to="localePath('/blog/types-of-diamond-cut-shape')">diamond shape</NuxtLink> best for you within your budget range. Hence the first step on how to pick your engagement ring is first to <NuxtLink :to="localePath('/blog/how-to-set-engagement-ring-budget')">set a budget</NuxtLink> so that you're ready with a number in mind when making your engagement ring purchase. <br><br>
                        You'd be happy to know that you'll be saving a lot of money on your purchase as <NuxtLink :to="localePath('/lab-diamonds')">lab diamonds</NuxtLink> are both eco-friendly and sustainable and priced better than mined diamonds. <br><br>
                        But we still recommend setting your budget first to make your shopping experience a far more easy and stress-free experience by finding a ring in your price range.
                    </p>
                    <NuxtLink class="radious_four" :to="localePath('/engagement-ring-guide/ring-cost')">Know more</NuxtLink>
                </div>      
            </div>

            <div class="row guide_block align-items-center py-4">
                <div class="col-md-7 col-12">
                    <h5>Step 2</h5>
                    <h4 class="mb-3 font-active">Choose A Setting</h4>
                    <p v-if="$country.is_india">
                        Choosing the right setting for your engagement ring is like selecting the perfect backdrop for your love story. When it comes to buying an engagement ring, the setting steals the spotlight as one of the most elegant features. It's not just about how the ring looks; it's about the style, the aesthetics, and the way it enhances the beauty of your diamond.
                        <br><br>
                        While the term "ring setting" refers to the style and visual appeal of your diamond engagement ring, it's the artistic touch that frames and highlights your precious stones.  <br><br>
                        From classic solitaires that exude timeless elegance to trendy halos that add a touch of glamour, Friendly Diamonds offers a diverse range of rings to suit various preferences.
                    </p>
                    <p v-else>
                        A ring setting is one of the most essential features you should pay attention to when buying an engagement ring. The 
                        <NuxtLink :to="localePath({ name:'cyo-setting-list-ring'})" >ring setting</NuxtLink> refers to the way the diamond engagement ring is styled. It also refers to its aesthetic appeal. Your ring setting highlights your diamond or diamonds if you decide to get more than one gem set on your ring. <br><br>
                        With a variety of ring styles available, including <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'solitaire-engagement-rings' } })" >halo</NuxtLink>, <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'three-stone-engagement-rings' } })" >three stone</NuxtLink>, <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'vintage-engagement-rings' } })" >vintage</NuxtLink>, 
                        <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'halo-engagement-rings' } })" >halo</NuxtLink>, and 
                        <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'side-stone-engagement-rings' } })" >side stone</NuxtLink>
                        , you can choose one that truly defines your partner's style and puts the spotlight on your diamond precisely the way you desire.
                    </p>
                    <NuxtLink :to="localePath('/engagement-ring-guide/types-of-ring-settings')" class="radious_four">Know more</NuxtLink>
                </div>
                
                <div class="col-md-5 col-12">
                    <picture>
                        <source width="550" height="550" type="image/webp" srcset="~/assets/eng-guide/step/choose_setting.webp">
                        <img loading="lazy" class="my-3 radious_eight" height="550" width="550" type="image/jpeg" src="~/assets/eng-guide/step/choose_setting.jpg" alt="Choose a setting">
                    </picture>
                </div>

                <div class="col-md-12 col-12">
                    <CommonStyleSlider />
                </div>
            </div>

            <div><hr></div>

            <div class="guide_block py-4">
                <h5>Step 3</h5>
                <h4 class="mb-3 font-active">Choose A Diamond</h4>
                <p v-if="$country.is_india">
                    Choosing the perfect diamond for your engagement ring is a deeply personal and symbolic decision. Each diamond possesses distinct characteristics and selecting one that resonates with your heart is an important step in the engagement ring journey. A diamond can be round, <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'princess-cut-diamond' } })">princess</NuxtLink>, <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'emerald-cut-diamond' } })">emerald</NuxtLink>, <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'cushion-cut-diamond' } })">cushion</NuxtLink>, <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'pear-cut-diamond' } })">pear</NuxtLink>, <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'radiant-cut-diamond' } })">radiant</NuxtLink>, <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'oval-cut-diamond' } })">oval</NuxtLink>, <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'heart-cut-diamond' } })">heart</NuxtLink>, <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'asscher-cut-diamond' } })">asscher</NuxtLink>, or <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'marquise-cut-diamond' } })">marquise</NuxtLink> in shape.  <br><br>
                    <NuxtLink :to="localePath('/4-cs-diamond')">The 4 C’s</NuxtLink>—carat, cut, colour and clarity—serve as guiding factors. For those drawn to timeless elegance and sparkle, a <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'round-cut-diamond' } })">round brilliant cut</NuxtLink> may be the ideal choice, while a more contemporary and bold style could be expressed through a unique fancy cut like emerald or princess. The colour of the diamond adds another layer of personalisation. Ultimately, your engagement ring stands as a symbol of your love and a testament to your individuality. <br><br>
                    If you are looking for ethically sourced and earth-kind diamonds- lab diamonds are the way to go. Imagine the moment of saying "yes" and consider how the diamond will showcase your journey together. Whether a classic solitaire, a vintage-inspired halo, or a modern  <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'three-stone-engagement-rings' } })">three-stone setting</NuxtLink>, an engagement ring is a lasting expression of your love story.
                </p>
                <p v-else>
                    Diamonds, as mentioned earlier, are an absolute classic choice for engagement rings. Understanding the diamonds' 4C's, i.e., cut, color, clarity, and carat weight, is the best way to identify the perfect diamond within your budget for your engagement ring. <NuxtLink :to="localePath('/4-cs-diamond')">The 4C's</NuxtLink> are part of the <NuxtLink :to="localePath('/blog/igi-certificate-vs-gia-certified-diamonds')">diamond certification</NuxtLink> process and are precisely what makes every diamond unique. The better you understand them, the easier your diamond engagement purchase shall be. <br><br>
                    You will also soon realize that diamonds come in many shapes. Diamond shapes include <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'round-cut-diamond' } })">brilliant round</NuxtLink>, 
                    <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'princess-cut-diamond' } })">princess</NuxtLink>, 
                    <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'cushion-cut-diamond' } })">cushion</NuxtLink>, <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'emerald-cut-diamond' } })">emerald</NuxtLink>, <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'marquise-cut-diamond' } })">marquise</NuxtLink>, oval, radiant, 
                    <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'heart-cut-diamond' } })">heart</NuxtLink>, <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'pear-cut-diamond' } })">pear</NuxtLink>, and 
                    <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'asscher-cut-diamond' } })">asscher cuts</NuxtLink>. There is a diamond shape for everybody; for those who are inspired by fashion from the timeless vintage era and for those who love elegance and trends of the modern times. <br><br>
                    With such an eclectic choice presented before you at Friendly diamond you are sure to pick a diamond that is an extension of your partner's personality and have him/her saying Yes!
                </p>
                <NuxtLink :to="localePath('/engagement-ring-guide/types-of-diamonds')" class="radious_four">Know more</NuxtLink>
                <CommonShapeSlider />
            </div>         

            <div><hr></div>

            <div class="guide_block py-4">
                <h5>Step 4</h5>
                <h4 class="mb-3 font-active">Complete Your Ring</h4>
                <p v-if="$country.is_india">
                    A good fit is crucial when choosing a ring, as nobody would want the ring to slip off or snug the finger. While it might seem like a small detail, the right ring size is a big part of the overall comfort and enjoyment of wearing your engagement ring every day. <br><br>
                    Furthermore, you can also give your ring a personal touch by considering engraving. Whether it's a significant date, initials, or a heartfelt message, engraving adds a unique and sentimental aspect to your ring. It's a subtle yet powerful way to make your engagement ring truly yours.
                    As you set out on this journey together, you might want to think about matching bands that represent your unity. “Matching” does not have to mean exactly the same; it could be a shared feature in the design that unites the two rings to each other. This thoughtful choice creates a tangible link, reminding you of the shared commitment.  <br><br>
                    If you want to explore more about engagement rings and determine your actual size, you could visit our <NuxtLink :to="localePath('/customer-service/ring-resizing')">Ring Size Guide</NuxtLink> to learn more.
                </p>
                <p v-else>
                    So you planned your budget, chose your diamond and picked a ring setting. Now it is time to complete your ring. <br><br>
                    Adding a personal touch to your ring is a great way to add a finishing touch to complete it. It could be an engraving with a special message or the date on when the both of you first met inscribed on the inner side of the ring. It makes your engagement much more special. <br><br>
                    We’d also like to add to this guide that it is essential to know your partner’s <NuxtLink :to="localePath('/customer-service/ring-resizing')">ring size</NuxtLink>. You can get to know of it by measuring a ring that your partner already owns or doing so with a <NuxtLink :to="localePath('/how-to-find-ring-size')">ring sizer guide</NuxtLink>. You can also add a <NuxtLink :to="localePath({ name: 'shop-couple-rings', params:{ category: 'couple-rings' }})">matching band</NuxtLink> to it to have a lovely sparkling pair of rings. <br><br>
                    Completing your ring is the final step in creating your very own engagement ring, but it is the beginning of a whole new life with your beloved when he or she sets eyes on it and accepts you as a partner for life.
                </p>
                <NuxtLink class="radious_four" :to="localePath('/engagement-ring-guide/complete-the-ring')">Know more</NuxtLink>
            </div>
            
            <div> <hr> </div>

            <div class="row guide_block align-items-center py-4">
                <div class="col-md-5 col-12">
                    <picture v-if="$country.is_india">
                        <!-- <source width="550" height="550" type="image/webp" srcset="~/assets/eng-guide/step/india/time_to_propose.gif"> -->
                        <img loading="lazy" class="my-3" height="550" width="550" type="image/jpeg" src="~/assets/eng-guide/step/time_to_propose.jpg" alt="What are you waiting for? Time to Propose" />
                    </picture>

                    <picture v-else>
                        <source width="550" height="550" type="image/webp"
                            srcset="~/assets/eng-guide/step/time_to_propose.webp">
                        <img loading="lazy" class="my-3 radious_eight" height="550" width="550" type="image/jpeg"
                            src="~/assets/eng-guide/step/time_to_propose.jpg"
                            alt="What are you waiting for? Time to Propose" />
                    </picture>
                </div>
                <div class="col-md-7 col-12">
                    <h5>Step 5</h5>
                    <h4 class="mb-3 font-active" v-if="$country.is_india">
                      Why Not Make Your Love Story Last A Lifetime?
                    </h4>
                    <h4 class="mb-3 font-active" v-else>
                      What are you waiting for? Time to Propose
                    </h4>
                    <p v-if="$country.is_india">
                      The time is right, and the ring is ready—a symbol of your love story waiting to be eternally written. The brilliance of a 
                      <NuxtLink :to="localePath({ name: 'cyo-diamond-list-ring' })">diamond ring</NuxtLink> 
                      captures not just the shine at the moment but also promises a lifetime of shared joy, love, and treasured memories as you set off on this journey.
                      <br><br>
                      From the classic beauty of a round-cut diamond to the contemporary charm of a princess or the classic appeal of an emerald cut, picture a ring made just for you, a breathtaking souvenir of your journey together. Every choice is a masterpiece ready to adorn your love.
                    </p>
                    <p v-else>
                      With a ring you cherish, all that remains for you is to pop the question and ask your significant other to be your one and only!
                      <br><br>
                      You may have created a 
                      <NuxtLink :to="localePath({ name: 'cyo-setting-list-ring', params: { start_with: 'vintage-engagement-rings' } })">vintage-style ring</NuxtLink> 
                      crafted with 
                      <NuxtLink :to="localePath({ name: 'cyo-setting-list-ring', params: { start_with: 'yellow-gold-engagement-rings' } })">yellow gold</NuxtLink>. 
                      Or perhaps an ultra-modern 
                      <NuxtLink :to="localePath({ name: 'cyo-setting-list-ring', params: { start_with: 'white-gold-engagement-rings' } })">white gold ring</NuxtLink> 
                      with the trending 
                      <NuxtLink :to="localePath({ name: 'loose-listing', params: { start_with: 'oval-cut-diamond' } })">oval diamond</NuxtLink>, 
                      or maybe an amalgamation of the classic and contemporary with a 
                      <NuxtLink :to="localePath({ name: 'loose-listing', params: { start_with: 'radiant-cut-diamond' } })">radiant cut diamond</NuxtLink> 
                      on a 
                      <NuxtLink :to="localePath({ name: 'cyo-setting-list-ring', params: { start_with: 'rose-gold-engagement-rings' } })">rose gold metal band</NuxtLink>; 
                      whichever you pick, it is a unique representation of the love the both of you share.
                      <br><br>
                      And when you have a beautiful ring to present, it is only fair that you plan a proposal that'll be a moment always to remember. It's up to you to create this moment and make it the best day ever.
                      <br><br>
                      Read our unique ideas to make your proposal unforgettable, having your partner gleaming with a smile while you place the ring around his or her finger.
                    </p>
                    <NuxtLink class="radious_four" :to="localePath('/engagement-ring-guide/time-to-propose')">Know more</NuxtLink>
                </div>
            </div>

            <div><hr></div>

            <div class="guide_block pt-4">
                <p v-if="$country.is_india">
                    Our expert artisans ensure that every detail is perfect, from the cut that captures light in a dance of brilliance to the setting that cradles the diamond in a design as unique as your love story. <br><br> 
                    The time is now, the ring is waiting, and your love deserves nothing less. Let us create the ring that tells your tale, a piece of eternity designed just for you.
                </p>
                <p v-else>We’d like to end by saying that when it comes to engagement rings and wedding bands there are a variety of ring styles and precious metals to choose from. And as long as you know all there is to know about your partner when it comes to his or her style, fashion sense and personality, you’re sure to find the perfect ring that is a true symbol of your love by following this guide crafted to make your engagement ring purchase a simple, easy and beautiful experience.</p>
                <p>So get on with your special surprise and create your engagement ring today!</p>
            </div>

            <div class="row cta_block">
                <div class="col-md-12 col-12 mx-auto px-0 d-flex align-items-center justify-content-center font-active">
                    <NuxtLink :to="localePath('/engagement-ring-guide/ring-cost')">
                        Next
                        <div class="arrow_eng">
                            <SvgHeaderSvg :type="'right'" />
                        </div>
                        Set A Budget
                    </NuxtLink>
                </div>
            </div>
            
        </div>
    </section>
</template>


<script setup>
    const localePath = useLocalePath()
    const { $country } = useNuxtApp()
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );
</script>



<style scoped>
.eng_guide_banner {
    position: relative;
}
.eng_guide_upper {
    position: absolute;
    top: 50%;
    left: 20%;
    width: 25%;
    transform: translate(-50%,-50%);
}
 .eng_guide_upper h2 {
    font-size: 16px;
    font-weight: 500;
    text-transform: capitalize;
}
.eng_guide_upper h1 {
    font-size: 32px;
    color: var(--green);
    font-weight: 500;
    text-transform: capitalize;
}
.eng_guide_upper h1 span{
    font-size: 16px;
    font-weight: 500;
    text-transform: capitalize;
    color: #000;
    display: block;
    font-family: Lato;
    margin-bottom: 2%;
}
.eng_guide_upper p {
    font-size: 14px;
    font-weight: 500;
    /* text-transform: capitalize; */
    color: #000;
    line-height: 1.8;
}
.eng_guide_flex {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.eng_guide_flex a {
    display: inline-block;
    font-size: 14px;
    padding: 1.5% 5%;
    color: #000;
    text-transform: unset;
    font-weight: 400;
    border: 1px solid #000;
    text-transform: capitalize;
}
/* -------cta */
.row.cta_block a {
    display: flex;
    align-items: center;
    color: #000;
    font-size: 18px;
}
.row.cta_block span {
    font-size: 25px;
    margin: 0 15px;
    font-weight: 300;
}
.row.cta_block {
    margin: 4% 0;
}
/* -------cta */
@media(max-width:1350px ){
    .eng_guide_upper{
        width: 50%;
        left: 30%;
    }
}
@media(max-width:1024px ){
    .eng_guide_upper h1 {
        font-size: 32px;
    }
    .eng_guide_banner img {
        height: 45vh;
        object-fit: cover;
        object-position: 100%;
    }
}
@media(max-width:992px ){
    .eng_guide_banner img{
        display: none;
    }
    .eng_guide_upper {
        width: 100%;
        left: 0;
        transform: unset;
        position: relative;
        top: 0;
    }
    .guide_block_banner {
        padding: 0 36px 5% 36px;
        border-bottom: 1px solid #ccc;
    }
     /* -------cta */
     .row.cta_block a {
        font-size: 16px;
    }
    /* -------cta */
}
@media(max-width:767px ){
    .arrow_eng {
        /* font-size: 40px; */
    }
    .eng_guide_upper h1 {
        font-size: 32px;
    }
    .guide_block_banner {
        padding: 0% 18px 8% 18px;
        border-bottom: 1px solid #ccc;
    }
    /* -------cta */
    .row.cta_block a {
        font-size: 14px;
    }
    /* -------cta */
}
/* -------------------------------------------------------------- */

.guide_block h2 {
    font-size: 32px;
    text-transform: capitalize;
    color: var(--green);
}
.guide_block h5 {
    font-size: 16px;
    font-weight: 600;
    color: #6a6161;
}

.guide_block h4 {
    font-size: 26px;
}
.guide_block h4 span{
    color: var(--green);
}
.guide_block p {
    font-size: 16px;
    color: #6a6161;
    font-weight: 500;
}
.guide_block h3 {
    font-size: 16px;
    font-weight: 600;
    color: var(--green);
}
.guide_block a {
    display: inline-block;
    font-size: 14px;
    padding: 10px 20px;
    color: #000;
    border: 1px solid #000;
    text-transform: uppercase;
    font-weight: 600;
}
.guide_block p a {
    background: none;
    padding: 0;
    font-size: 16px;
    text-transform: unset;
    color: #6a6161;
    font-weight: 500;
    border: 0;
    text-decoration: underline;
    color: var(--green);
}
@media(max-width: 992px){
    .guide_block h2 {
        font-size: 26px;
        margin-top: 4%;
    }
  

}

@media(max-width: 400px){
    .eng_guide_flex {
        flex-wrap: wrap;
    }

    .eng_guide_flex a {
        width: 100%;
        margin-right: 0 !important;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 10px;
    }
}
@media(max-width: 767px){
    .row_mod {
        flex-direction: column-reverse;
    }

    .guide_block h2 {
        font-size: 24px;
        margin-top: 6%;
    }
    .guide_block h4{
        font-size: 24px;
    }
    .guide_block p {
        margin: 3% 0 !important;
    }
    .guide_block a {
        margin-top: 5%;
    }
    .guide_block h3 {
        font-size: 16px;
    }
    
}
</style>